// utils/upload_pics.js
import axiosInstance from '../../../api/axiosInstance';
import { stampMode } from './stampMode';

const CDN_PREFIX_RE = /^\/?cdn\/photos\/?/i;
const MODE_PREFIX_RE  = /\/(ps|ms|cb|ac|bundles|misc)\//i;
/**
 * Turn anything we may find in `photo_url` into a bare storage path
 *    – `/cdn/photos/ps/123.jpg`        → `ps/123.jpg`
 *    – `https://…/bucket/ps/123.jpg?…` → `ps/123.jpg`
 *    – `ps/123.jpg`                    → `ps/123.jpg`  (unchanged)
 */
function toStoragePath(url = "") {
  if (!url) return url;

  // Signed URL → strip domain & query-string
  if (url.startsWith("http")) {
    try {
      const { pathname } = new URL(url);
      url = pathname;          // keep “/bucket/folder/file.ext…”
    } catch {
      /* noop – malformed URL, treat as relative */
    }
  }
  url = url.replace(CDN_PREFIX_RE, "");

  // 2️⃣ Remove the first leading slash
  url = url.replace(/^\/+/, "");

  // 3️⃣ If there is still an extra folder before the real mode-folder
  //     (e.g.  "uploads/ps/123.jpg")   →   "ps/123.jpg"
  const pos = url.search(MODE_PREFIX_RE);
  if (pos > 0) url = url.slice(pos + 1);    // +1 to skip the slash

  return url;
 }

export async function uploadAllImages(formData, businessId, modes = []) {
  const FOLDER = {
    personal_services: 'ps',
    modular_seating  : 'ms',
    class_based      : 'cb',
    accommodation    : 'ac',
    bundles          : 'bundles',
  };
  stampMode(modes, formData)
  async function walk(node, modeCtx = null) {
    // Arrays → walk each element with the same mode context
    if (Array.isArray(node)) {
      await Promise.all(node.map(child => walk(child, modeCtx)));
      return;
    }

    // Objects → may contain uploads or nested structures
    if (node && typeof node === 'object') {
      // Prefer an explicit mode on the current node; otherwise inherit
      const mode = node.mode ?? modeCtx;

      if ("photo_url" in node && typeof node.photo_url === "string") {
        node.photo_url = toStoragePath(node.photo_url);
      }
      if ('uploadFile' in node) {
        console.log('🟡 uploadFile found:', node.uploadFile);
        console.log('🧪 Is it a File?', node.uploadFile instanceof File);
      }

      // ⬇️ NEW: Support multiple images (e.g., for accommodation)
      if (Array.isArray(node.images)) {
        const uploaded = [];
        for (const file of node.images) {
          if (!(file instanceof File)) {
            uploaded.push(toStoragePath(file)); // already uploaded (e.g., string path)
            continue;
          }

          const ext = file.name.slice(file.name.lastIndexOf('.')) || '';
          const folder = FOLDER[mode] ?? 'misc';

          // Ask backend for a presigned URL
          const { data } = await axiosInstance.post(
            '/files/photos/presign',
            {
              contentType: file.type,
              extension: ext,
              folder,
            },
            {
              params: { business_id: businessId },
            }
          );

          // Upload file
          try {
            const res = await fetch(data.uploadUrl, {
              method: 'PUT',
              headers: { 'Content-Type': file.type },
              body: file,
            });

            if (!res.ok) {
              throw new Error(`Upload failed with status ${res.status}`);
            }

            uploaded.push(data.path);
          } catch (err) {
            console.error('🔥 Upload failed:', err);
            throw err;
          }
        }

        node.images = uploaded; // replace File[] with path[]
      }


      // ───── Upload fresh file ────────────────────────────────────────
      if (node.uploadFile instanceof File) {
        const file = node.uploadFile;
        const ext  = file.name.slice(file.name.lastIndexOf('.')) || '';
        const folder = FOLDER[mode] ?? 'misc';

        // 1. Ask backend for a presigned URL
        const { data } = await axiosInstance.post('/files/photos/presign', {
          contentType: file.type,
          extension: ext,
          folder,
        }, {
          params: {
           business_id: businessId,
          },
        });

try {
  const res = await fetch(data.uploadUrl, {
    method : 'PUT',
    headers: { 'Content-Type': file.type },
    body   : file,
  });

  if (!res.ok) {
    throw new Error(`Upload failed with status ${res.status}`);
  }
} catch (err) {
  console.error('🔥 Upload failed:', err);
  throw err; // rethrow to trigger outer error handling
}


        // 3. Replace upload info with the public URL expected by the API
        node.photo_url = data.path;
        console.log(data.path);
        delete node.uploadFile;
        delete node.uploadPreview;
      }

      // Recurse into children, propagating mode
      await Promise.all(
        Object.values(node).map(child => walk(child, mode))
      );
    }
  }

  await walk(formData);
}
